module.exports = __webpack_public_path__ + "img/book-module-relation-info.23cd51e8.png";